import React, { forwardRef } from 'react';
import '../../styles/foundation/FullContentPage.css';

const FullContentPage = forwardRef(
    ({ children, isDisabled = false }, ref) => {
        return (
            <div ref={ref} className={`full-content-page ${isDisabled ? 'disabled' : ''}`}>
                {children}
            </div>
        );
    }
);

FullContentPage.displayName = 'FullContentPage';

export default FullContentPage;
